<template>
  <div class="banner">
    <div class="column column1">
      <div class="title">We value collaboration</div>
    </div>
    <div class="column column2">
      <div class="mediumTitle">
        Interested in helping? Get in touch at
        <a href="mailto:askaway@orium.com" class="highlight">askaway@orium.com</a>
      </div>
      <div
        class="subheading"
      >Help us determine Askaway’s improvement roadmap. In the backlog already: updating and refactoring the codebase, new user profile interactions, and enabling more than one login protocol.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Collaboration",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  background-color: #f3f1f2;
  width: 60%;
  height: 375px;
  color: #22272b;
  padding: 80px;
  padding-top: 60px;
  margin-bottom: 40px;
  z-index: 1;
}

.banner .highlight {
  color: #f25930;
}

.column {
  display: flex;
  width: 40%;
  margin: 20px;
  margin-right: 40px;
}

.column2 {
  flex-direction: column;
  width: 60%;
  text-align: left;
  margin-right: 20px;
}

.banner .title {
  font-size: 40px;
  text-align: left;
  line-height: 50px;
  font-family: "SofiaProBold";
}

.banner .mediumTitle {
  font-size: 22px;
  line-height: 31px;
}
.banner .subheading {
  font-size: 20px;
  line-height: 28px;
  margin-top: 40px;
  color: #66636b;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .banner {
    width: 80%;
    margin: 0 auto;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .banner {
    width: 80%;
    margin: 0 auto;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 40px;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  .banner {
    width: 100%;
    padding-top: 40px;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .banner {
    width: 100%;
    padding: 40px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .banner .title {
    font-size: 30px;
    line-height: 40px;
  }

  .banner .mediumTitle {
    font-size: 20px;
    line-height: 26.66px;
  }

  .banner .subheading {
    font-size: 20px;
    line-height: 26.66px;
    margin-top: 15px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .banner {
    width: 100%;
    height: 315px;
    margin: 0 auto;
    padding: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .banner .title {
    font-size: 20px;
    line-height: 26.66px;
    font-family: "SofiaProBold";
  }

  .column {
    margin: 10px;
  }

  .banner .mediumTitle {
    font-size: 16px;
    line-height: 21.33px;
  }
  .banner .subheading {
    font-size: 16px;
    line-height: 21.33px;
    margin-top: 15px;
  }
}
</style>
